import { ChangeDetectorRef, Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import { GoogleMapsService } from '../../../services/google-map.services';

@Component({
  selector: 'app-geo-point',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, DropdownModule, TranslateModule, ButtonModule, DialogModule, BlockUIModule, InputTextModule],
  templateUrl: './geo-point.component.html',
  styleUrl: './geo-point.component.scss'
})

export class GeoPointComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  @Output() onAddressChange: EventEmitter<any> = new EventEmitter();
  defaultLbl: string;
  placeholder: any;
  map: google.maps.Map;
  infoWindow: google.maps.InfoWindow;
  visible: boolean = false;

  zoom = 4;
  position: any;
  cancelBtnText: any;
  saveBtnText: any;
  blockedDocument: boolean = false;
  newGeoLocation: any;
  premiseAddress;
  marker;
  showGoogleSearchBox: boolean = false;
  searchText: string = null;
  suggestions: any = [];

  constructor(
    private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService,
    private entityService: EntityService,
    private cd: ChangeDetectorRef,
    private googleMapsService: GoogleMapsService) {
    this.formName = formGroupDirective.control;
  }

  ngOnInit(): void {
    this.cancelBtnText = this.cs.getLabel("cancel");
    this.saveBtnText = this.cs.getLabel("label_save");
    this.defaultLbl = this.cs.getLabel("lbl_please_select");
    this.placeholder = this.cs.getLabelValue(`${this.moduleName  }.fields.${  this.field.attributeCode  }.placeholder`, this.attributeLabels, this.field.attributeCode);
  }

  changedValue() {
    this.cd.markForCheck();
  }

  showDialog() {
    this.visible = true;
    this.blockedDocument = true;
    this.showGoogleSearchBox = true;
    this.initMap();
  }

  close() {
    this.visible = false;
    this.blockedDocument = false;
    this.showGoogleSearchBox = false;
  }

  saveGeoLocation() {
    let index = -1;
    if (this.field.presetValues && this.field.presetValues.length > 0) {
      index = this.field.presetValues.findIndex(ele => ele.labelKey === this.newGeoLocation);
    } else {
      this.field.presetValues = [];
    }

    if (index === -1) {
      this.field.presetValues.push({ labelKey: this.newGeoLocation, labelValue: this.newGeoLocation, parentLabelKey: null });
      this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].setValue(this.newGeoLocation);
    }
    this.visible = false;
    this.blockedDocument = false;
    this.showGoogleSearchBox = false;
  }

  async initMap(): Promise<void> {
    this.searchText = null;
    const { Map } = await google.maps.importLibrary('maps') as google.maps.MapsLibrary;
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker') as google.maps.MarkerLibrary;
    this.map = new Map(document.getElementById('map') as HTMLElement, {
      center: this.googleMapsService.getEventLocationCoordinates(),
      zoom: 8,
      mapTypeControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: this.googleMapsService.mapId
    });

    this.infoWindow = new google.maps.InfoWindow();
    const element = document.getElementById('googleSearch');
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(element);
    element.focus();

    const marker = new AdvancedMarkerElement({
      map: this.map,
      position: this.position,
      gmpDraggable: true
    });

    const options = {
      fields: ['formatted_address', 'geometry', 'name'],
      strictBounds: false,
    };

    const inputHtmlElement = document.getElementById('autocompleteSearch') as HTMLInputElement;
    const autocomplete = new google.maps.places.Autocomplete(inputHtmlElement, options);
    autocomplete.bindTo('bounds', this.map);

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport);
      } else {
        this.map.setCenter(place.geometry.location);
        this.map.setZoom(17);
      }
      marker.position = place.geometry.location;
      const latLong = `${place.geometry.location.lat()  }, ${  place.geometry.location.lng()}`;
      this.getReverseGeoCodeFromLatLng(latLong);
    });


    this.position = this.googleMapsService.getEventLocationCoordinates();
    marker.position = this.position;
    const latLong = `${this.position.lat  }, ${  this.position.lng}`;
    this.getReverseGeoCodeFromLatLng(latLong);
    marker.addListener('dragend', () => {
      const currentPosition = marker.position as google.maps.LatLng;
      this.position = { lat: currentPosition.lat, lng: currentPosition.lng };
      const latLong = `${this.position.lat  }, ${  this.position.lng}`;
      this.getReverseGeoCodeFromLatLng(latLong);
    });
    this.map.panTo(this.position);
  }

  getReverseGeoCodeFromLatLng(latLong) {
    this.entityService.getReverseGeoCodeUsingLatLng(latLong).subscribe((result: any) => {
      if (result && result.results.length > 0) {
        const { lat, lng } = result.results[0].geometry.location
        this.newGeoLocation = `${lat},${lng}`
      }
    })
  }

}
